import { rootApi } from "@/services/api/api";
import type { GetVcfImportStatusResponse, ImportVcfRequest, ImportVcfResponse } from "../types";

const fileApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    importVcf: build.mutation<ImportVcfResponse, ImportVcfRequest>({
      query: (file) => ({
        url: "/import/vcf",
        method: "POST",
        body: file,
      }),
    }),
    getVcfImportStatus: build.query<GetVcfImportStatusResponse, void>({
      query: () => ({
        url: "/import/vcf/status",
        method: "GET",
      }),
    }),
  }),
});

export const { useImportVcfMutation, useLazyGetVcfImportStatusQuery } = fileApi;
